<script>
  import { onMount } from "svelte";
  import {
    addHash,
    decorateMember,
    decorateTransaction,
    decorateAction,
    transferTypes,
    actionTypes,
    memberTypes,
    localeOrderBy,
    slice,
    loadPersisted,
    savePersisted,
  } from "../../mjnUtils";
  import Pagination from "./pagination/Pagination.svelte";

  let { http, toastr, goTo, id, tab } = $props();

  let member = $state(null);
  let memberTransactions = $state([]);
  let memberActions = $state([]);
  let memberSkillsOthers = $state(null);
  let memberSkills = $state([]);
  let memberExperiences = $state([]);
  let showAddGroup = $state(false);
  let allWorkspaceGroups = $state(null);
  let selectedGroup = $state(null);
  let activeTab = $state(tab || 1);
  let sortTypeTr = $state(loadPersisted("member-detail", "sortTypeTr", "data"));
  let sortReverseTr = $state(loadPersisted("member-detail", "sortReverseTr", false));
  let currentPageTr = $state(1);
  let sortType = $state("");
  let sortReverse = $state(false);
  const itemsPerPage = 10;

  $effect(() => {
    savePersisted("member-detail", "sortTypeTr", sortTypeTr);
    savePersisted("member-detail", "sortReverseTr", sortReverseTr);
  });

  onMount(() => {
    Promise.all([
      http.get("/api/czlonek.php?id=" + id),
      http.get("/api/transakcja.php?idcz=" + id),
      http.get("/api/akcja.php?idcz=" + id),
      http.get("/api/projekt.php"),
      http.get("/api/kompetencje_inne.php?idcz=" + id),
      http.get("/api/kompetencje.php?idcz=" + id),
    ]).then(
      ([memberResponse, transactionsResponse, actionsResponse, projectsResponse, skillsOtherResponse, skillsResponse]) => {
        if (
          memberResponse.data.status === 200 &&
          transactionsResponse.data.status === 200 &&
          actionsResponse.data.status === 200 &&
          projectsResponse.data.status === 200 &&
          skillsOtherResponse.data.status === 200 &&
          skillsResponse.data.status === 200
        ) {
          const members = addHash(memberResponse.data.records, "idcz");
          decorateMember(members[0]);
          member = members[0];

          const projects = addHash(projectsResponse.data.records, "idpr");
          const transactions = transactionsResponse.data.records;
          for (const transaction of transactions) {
            decorateTransaction(transaction, members, projects, transferTypes);
          }
          memberTransactions = transactions;

          const actions = actionsResponse.data.records;
          for (const action of actions) {
            decorateAction(action, members, actionTypes);
          }
          memberActions = actions;

          memberSkillsOthers = skillsOtherResponse.data.records[0];
          memberSkills = skillsResponse.data.skills;
          memberExperiences = skillsResponse.data.experiences;
        } else {
          alert(
            "Błąd: " +
              memberResponse.data.message +
              ", " +
              transactionsResponse.data.message +
              ", " +
              actionsResponse.data.message +
              ", " +
              projectsResponse.data.message +
              ", " +
              skillsOtherResponse.data.message +
              ", " +
              skillsResponse.data.message,
          );
        }
      },
      () => {
        toastr.error("Błąd połączenia");
      },
    );
  });

  function suspendWorkspace() {
    const name = member.imie + " " + member.nazwisko;
    if (!confirm("Zablokować konto Workspace dla " + name + "?")) return;
    http.patch("/api/workspace.php?id=" + id).then(
      (response) => {
        if (response.data.status === 200) {
          toastr.success("Zablokowano konto Workspace dla " + name);
          http.get("/api/workspace.php?id=" + id).then((r) => {
            if (r.data.status === 200) {
              member.workspace_status = r.data.workspace_status;
            }
          });
        } else {
          toastr.error("Błąd blokowania konta");
        }
      },
      () => {
        toastr.error("Błąd połączenia");
      },
    );
  }

  function toggleAddGroup() {
    showAddGroup = !showAddGroup;
    if (showAddGroup && allWorkspaceGroups === null) {
      http.get("/api/workspace.php").then(
        (response) => {
          allWorkspaceGroups = response.data.groups;
        },
        () => {
          toastr.error("Błąd pobierania listy grup");
        },
      );
    }
  }

  function addToGroup(groupEmail) {
    if (!groupEmail) return;
    const memberEmail = member.email_mjn || member.email;
    http.put("/api/workspace.php", { group: groupEmail, member: memberEmail }).then(
      (response) => {
        if (response.data.status === 200) {
          member.workspace_groups.push({ email: memberEmail, group: groupEmail });
          selectedGroup = null;
          showAddGroup = false;
          toastr.success("Dodano do grupy " + groupEmail);
        } else {
          toastr.error("Błąd dodawania do grupy");
        }
      },
      () => {
        toastr.error("Błąd połączenia");
      },
    );
  }

  function removeFromGroup(group, memberEmail) {
    const expected = group.substring(0, 5);
    const input = prompt(
      'Wpisz pierwsze 5 liter nazwy grupy aby potwierdzić usunięcie z "' + group + '":',
    );
    if (input !== expected) return;
    http
      .delete("/api/workspace.php", {
        data: { group, member: memberEmail },
        headers: { "Content-Type": "application/json" },
      })
      .then(
        (response) => {
          if (response.data.status === 200) {
            const groups = member.workspace_groups;
            const idx = groups.findIndex(
              (g) => g.group === group && g.email === memberEmail,
            );
            if (idx !== -1) groups.splice(idx, 1);
            toastr.success("Usunięto z grupy " + group);
          } else {
            toastr.error("Błąd usuwania z grupy");
          }
        },
        () => {
          toastr.error("Błąd połączenia");
        },
      );
  }

  function deleteMember() {
    if (confirm("Skasować osobę " + member.imie + " " + member.nazwisko + "?")) {
      http.delete("/api/czlonek.php?id=" + id).then(
        (response) => {
          if (response.data.status == 200) {
            toastr.info("Skasowano rekord osoby " + member.imie + " " + member.nazwisko);
            goTo("main");
          } else {
            toastr.error("Błąd: " + response.data.message);
          }
        },
        () => {
          toastr.error("Błąd połączenia");
        },
      );
    }
  }

  function updateTabs(newTab) {
    activeTab = newTab;
  }

  function setSortTr(field) {
    if (sortTypeTr === field) {
      sortReverseTr = !sortReverseTr;
    } else {
      sortTypeTr = field;
      sortReverseTr = false;
    }
  }

  function setSort(field) {
    if (sortType === field) {
      sortReverse = !sortReverse;
    } else {
      sortType = field;
      sortReverse = false;
    }
  }

  let availableGroups = $derived(
    !allWorkspaceGroups || !member
      ? []
      : allWorkspaceGroups.filter(
          (g) => !(member.workspace_groups || []).map((wg) => wg.group).includes(g.email),
        ),
  );

  let sortedTransactions = $derived(localeOrderBy(memberTransactions, sortTypeTr, sortReverseTr));
  let totalItemsTr = $derived(memberTransactions.length);
  let numPagesTr = $derived(Math.max(1, Math.ceil(totalItemsTr / itemsPerPage)));
  let pagedTransactions = $derived(slice(sortedTransactions, itemsPerPage, currentPageTr));

  let sortedActions = $derived(localeOrderBy(memberActions, sortType, sortReverse));
</script>

{#if member}
<h3>
    Dane: {member.imie} {member.nazwisko}
    <div class="btn-toolbar pull-right">
        <button
            class="btn btn-danger btn-sm pull-right"
            onclick={deleteMember}
        >
            <i class="fas fa-trash" aria-hidden="true"></i>
            <span class="hidden-xs">&nbsp;Skasuj</span>
        </button>
        <a
            class="btn btn-primary btn-sm pull-right"
            href={"/member-edit/" + id}
        >
            <i class="fas fa-edit" aria-hidden="true"></i>
            <span class="hidden-xs">&nbsp;Edytuj</span>
        </a>
        <a
            class="btn btn-primary btn-sm pull-right"
            href="/member-edit/-1"
        >
            <i class="fas fa-plus" aria-hidden="true"></i>
            <span class="hidden-xs">&nbsp;Dodaj nową osobę...</span>
        </a>
        <a class="btn btn-primary btn-sm pull-right" href="/">
            <i class="fas fa-chevron-left" aria-hidden="true"></i>
            <span class="hidden-xs">&nbsp;Powrót</span>
        </a>
    </div>
</h3>
<div class="clearfix"></div>
<div class="text-left">
    <small>
        <i class="fa fa-random" aria-hidden="true"></i>
        {member.imie} {member.nazwisko} jest skojarzony z
        {memberTransactions.length} przelewami i {memberActions.length}
        umorzeniami/zwolnieniami.
    </small>
    <p></p>
</div>

<div>
    <ul class="nav nav-tabs">
        <li class={activeTab==1 ? "active" : ""} onclick={() => updateTabs(1)}>
            <a href="#" onclick={(e) => e.preventDefault()}>Info</a>
        </li>
        <li class={activeTab==2 ? "active" : ""} onclick={() => updateTabs(2)}>
            <a href="#" onclick={(e) => e.preventDefault()}>Przelewy</a>
        </li>
        <li class={activeTab==3 ? "active" : ""} onclick={() => updateTabs(3)}>
            <a href="#" onclick={(e) => e.preventDefault()}>Umorzenia, zawieszenia</a>
        </li>
        <li class={activeTab==4 ? "active" : ""} onclick={() => updateTabs(4)}>
            <a href="#" onclick={(e) => e.preventDefault()}>Kompetencje</a>
        </li>
    </ul>
</div>

{#if activeTab==1}
<div>
    <table class="table table-condensed table-hover table-striped">
        <thead class="thead-default">
            <tr>
                <th>Dane</th>
                <th>Wartości</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>Unikalny identyfikator:</td>
                <td>{member.idcz}</td>
            </tr>
            <tr>
                <td>Imie i nazwisko:</td>
                <td>{member.imie} {member.nazwisko}</td>
            </tr>
            <tr>
                <td>Członkostwo:</td>
                <td>{member.typ_text}</td>
            </tr>
            <tr>
                <td>Data urodzenia:</td>
                <td>{member.data_urodzenia}</td>
            </tr>
            <tr>
                <td>Dzielnica:</td>
                <td>{member.dzielnica}</td>
            </tr>
            <tr>
                <td>Kod pocztowy:</td>
                <td>{member.kod_pocztowy}</td>
            </tr>
            <tr>
                <td>Adres e-mail:</td>
                <td>{member.email}</td>
            </tr>
            <tr>
                <td>Adres e-mail MJN:</td>
                <td>{member.email_mjn}</td>
            </tr>
            <tr >
                <td>Konto Google Workspace:</td>
                <td>
                    {#if member.workspace_status === "active"}<span>{member.email_mjn || "znaleziono konto"} <button class="btn btn-xs btn-warning" onclick={suspendWorkspace}>Zablokuj</button></span>{/if}
                    {#if member.workspace_status === "suspended"}<span>{member.email_mjn || "znaleziono konto"} (zawieszone)</span>{/if}
                    {#if member.workspace_status === null || member.workspace_status === undefined}<span>brak konta w Workspace <a href={"/mjn-email-edit/" + member.idcz} class="btn btn-xs btn-default">Utwórz konto mjn</a></span>{/if}
                </td>
            </tr>
            <tr>
                <td>Grupy Google Workspace:</td>
                <td>
                    {#if !member.workspace_groups || member.workspace_groups.length === 0}<span>nie jest przypisany do żadnej grupy</span>{/if}
                    {#if member.workspace_groups && member.workspace_groups.length > 0}
                    <ul class="list-unstyled" style="margin:0">
                        {#each member.workspace_groups as g}
                        <li>
                            {g.group} <small class="text-muted">({g.email})</small>
                            <a href="#" onclick={(e) => { e.preventDefault(); removeFromGroup(g.group, g.email); }} class="text-danger" style="margin-left:4px">&times;</a>
                        </li>
                        {/each}
                    </ul>
                    {/if}
                    <div style="margin-top:4px">
                        <button class="btn btn-xs btn-default" onclick={toggleAddGroup}>
                            <i class="fas fa-plus"></i>&nbsp;Dodaj do grupy
                        </button>
                        {#if showAddGroup}
                        <span style="margin-left:6px">
                            <select bind:value={selectedGroup} class="form-control input-sm" style="display:inline-block;width:auto">
                                <option value="">-- wybierz grupę --</option>
                                {#each availableGroups as g}<option value={g.email}>{g.name || g.email}</option>{/each}
                            </select>
                            <button class="btn btn-xs btn-primary" onclick={() => addToGroup(selectedGroup)} disabled={!selectedGroup} style="margin-left:4px">Dodaj</button>
                        </span>
                        {/if}
                    </div>
                </td>
            </tr>
            <tr>
                <td>Adres e-mail Slack:</td>
                <td>{member.email_slack}</td>
            </tr>
            <tr>
                <td>Numer telefonu:</td>
                <td>{member.nrtel}</td>
            </tr>
            <tr>
                <td>Nr uchwały przyjmującej:</td>
                <td>{member.nr_uchwaly}</td>
            </tr>
            <tr>
                <td>Data uchwały przyjmującej:</td>
                <td>{member.data_uchwaly}</td>
            </tr>
            <tr>
                <td>Data odejścia:</td>
                <td>{member.data_odejscia}</td>
            </tr>
            <tr>
                <td>Następny kontakt (windykacja):</td>
                <td>{member.nastepny_kontakt}</td>
            </tr>
            <tr>
                <td>Notatki:</td>
                <td>
                    <pre>{member.notka}</pre>
                </td>
            </tr>
            <tr>
                <td>Historia:</td>
                <td>
                    {#if member.history && member.history.length}
                    <ul class="list-unstyled">
                        {#each member.history as entry}
                        <li>
                            {entry.occurredAt} &mdash;
                            {memberTypes.hash[entry.status]?.name ?? entry.status}
                        </li>
                        {/each}
                    </ul>
                    {/if}
                </td>
            </tr>
        </tbody>
    </table>
</div>
{/if}
{#if activeTab==2}
<div>
    <table class="table table-condensed table-hover table-striped">
        <thead class="thead-default">
            <tr>
                <th>
                    <a
                        href="#"
                        onclick={(e) => { e.preventDefault(); setSortTr("data"); }}
                    >
                        Data transakcji
                        {#if sortTypeTr == "data" && !sortReverseTr}<span class="fa fa-caret-down"></span>{/if}
                        {#if sortTypeTr == "data" && sortReverseTr}<span class="fa fa-caret-up"></span>{/if}
                    </a>
                </th>
                <th>
                    <a
                        href="#"
                        onclick={(e) => { e.preventDefault(); setSortTr("opis"); }}
                    >
                        Opis transakcji
                        {#if sortTypeTr == "opis" && !sortReverseTr}<span class="fa fa-caret-down"></span>{/if}
                        {#if sortTypeTr == "opis" && sortReverseTr}<span class="fa fa-caret-up"></span>{/if}
                    </a>
                </th>
                <th class="hidden-xs">
                    <a
                        href="#"
                        onclick={(e) => { e.preventDefault(); setSortTr("kontrahent"); }}
                    >
                        Kontrahent dla transakcji
                        {#if sortTypeTr == "kontrahent" && !sortReverseTr}<span class="fa fa-caret-down"></span>{/if}
                        {#if sortTypeTr == "kontrahent" && sortReverseTr}<span class="fa fa-caret-up"></span>{/if}
                    </a>
                </th>
                <th>
                    <a
                        href="#"
                        onclick={(e) => { e.preventDefault(); setSortTr("kwota"); }}
                    >
                        Kwota
                        {#if sortTypeTr == "kwota" && !sortReverseTr}<span class="fa fa-caret-down"></span>{/if}
                        {#if sortTypeTr == "kwota" && sortReverseTr}<span class="fa fa-caret-up"></span>{/if}
                    </a>
                </th>
                <th class="hidden-xs">
                    <a
                        href="#"
                        onclick={(e) => { e.preventDefault(); setSortTr("typ_text"); }}
                    >
                        Rozpoznany typ
                        {#if sortTypeTr == "typ_text" && !sortReverseTr}<span class="fa fa-caret-down"></span>{/if}
                        {#if sortTypeTr == "typ_text" && sortReverseTr}<span class="fa fa-caret-up"></span>{/if}
                    </a>
                </th>
                <th class="hidden-xs hidden-sm">
                    <a
                        href="#"
                        onclick={(e) => { e.preventDefault(); setSortTr("info"); }}
                    >
                        Info
                        {#if sortTypeTr == "info" && !sortReverseTr}<span class="fa fa-caret-down"></span>{/if}
                        {#if sortTypeTr == "info" && sortReverseTr}<span class="fa fa-caret-up"></span>{/if}
                    </a>
                </th>
            </tr>
        </thead>

        <tbody>
            {#each pagedTransactions as ts}
            <tr>
                <td>{ts.data}</td>
                <td>{ts.opis}</td>
                <td class="hidden-xs">{ts.kontrahent}</td>
                <td>{ts.kwota}</td>
                <td class="hidden-xs">{ts.typ_text}</td>
                <td class="hidden-xs hidden-sm">{ts.info}</td>
            </tr>
            {/each}
        </tbody>
    </table>
    <Pagination {currentPageTr} {numPagesTr} onPageChange={(page) => currentPageTr = page}/>
</div>
{/if}
{#if activeTab==3}
<div>
    <table class="table table-condensed table-hover table-striped">
        <thead class="thead-default">
            <tr>
                <th>
                    <a
                        href="#"
                        onclick={(e) => { e.preventDefault(); setSort("typ_text"); }}
                    >
                        Typ
                        {#if sortType == "typ_text" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
                        {#if sortType == "typ_text" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
                    </a>
                </th>
                <th class="hidden-xs">
                    <a
                        href="#"
                        onclick={(e) => { e.preventDefault(); setSort("data_od"); }}
                    >
                        Data lub zakres
                        {#if sortType == "data_od" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
                        {#if sortType == "data_od" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
                    </a>
                </th>
                <th>
                    <a
                        href="#"
                        onclick={(e) => { e.preventDefault(); setSort("kwota"); }}
                    >
                        Kwota
                        {#if sortType == "kwota" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
                        {#if sortType == "kwota" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
                    </a>
                </th>
                <th class="hidden-xs">
                    <a
                        href="#"
                        onclick={(e) => { e.preventDefault(); setSort("uchwala"); }}
                    >
                        Uchwała
                        {#if sortType == "uchwala" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
                        {#if sortType == "uchwala" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
                    </a>
                </th>
            </tr>
        </thead>
        <tbody>
            {#each sortedActions as action}
            <tr>
                <td>{action.typ_text}</td>
                <td class="hidden-xs">
                    {action.data_od} {action.typ!=3 ? "" : (action.data_do===null ? "do odwołania" : "- "+action.data_do)}
                </td>
                <td>{action.kwota}</td>
                <td class="hidden-xs">{action.uchwala}</td>
            </tr>
            {/each}
        </tbody>
    </table>
</div>
{/if}
{#if activeTab==4}
<div>
    {#if !memberSkillsOthers}
    <p>
        Ankieta Mapy Kompetencji nie została wypełniona
    </p>
    {/if}
    {#if memberSkillsOthers}
    <table
        class="table table-condensed table-hover table-striped"
    >
        <thead class="thead-default">
            <tr>
                <th>Dane</th>
                <th>Wartość</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>Umiejętności:</td>
                <td>
                    {#each memberSkills as skill}
                    <ul>
                        <li>{skill}</li>
                    </ul>
                    {/each}
                </td>
            </tr>
            <tr>
                <td>Inne umiejętności:</td>
                <td>{memberSkillsOthers.inne_kompetencje}</td>
            </tr>
            <tr>
                <td>Dodatkowe umiejętności:</td>
                <td>{memberSkillsOthers.dodatkowe_kompetencje}</td>
            </tr>
            <tr>
                <td>Doświadczenia:</td>
                <td>
                    {#each memberExperiences as experience}
                    <ul>
                        <li>{experience}</li>
                    </ul>
                    {/each}
                </td>
            </tr>
            <tr>
                <td>Inne doświadczenia:</td>
                <td>{memberSkillsOthers.inne_doswiadczenia}</td>
            </tr>
            <tr>
                <td>Dodatkowe doświadczenia:</td>
                <td>{memberSkillsOthers.dodatkowe_doswiadczenia}</td>
            </tr>
            <tr>
                <td>Z czego jesteś dumna/y?</td>
                <td>{memberSkillsOthers.z_czego_dumna}</td>
            </tr>
            <tr>
                <td>Czego chciał/a/byś nauczyć się w MJN?</td>
                <td>{memberSkillsOthers.czego_nauczyc}</td>
            </tr>
        </tbody>
    </table>
    {/if}
</div>
{/if}
{/if}
